import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/girl-with-dog.png'


const _hoisted_1 = { class: "upgrade-plan-card card mb-4 border-0 text-center mb-4 border-radius d-block bg-white shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "fw-medium fs-24" }, "Upgrade Your Plan!", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mx-auto" }, " Access advanced features, enhanced support, and exclusive tools designed to help you achieve more. ", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "image" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "girl-with-dog"
          })
        ], -1)),
        _createVNode(_component_RouterLink, {
          to: "/dashboard/pricing",
          class: "btn btn-primary text-white"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "d-inline-block position-relative" }, [
              _createElementVNode("i", { class: "ri-fire-fill" }),
              _createTextVNode(" Upgrade Plan ")
            ], -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}